'use client'
import { createInstance } from "@hackler/react-sdk";

export const HackleClient = createInstance(
    process.env.NEXT_PUBLIC_HACKLE_BROWSER_SDK_KEY as string,
);
